import React, { useCallback, useEffect } from "react";
import { useOrganizationFromRouterQuery } from "@dewo/app/containers/organization/hooks";
import { OrganizationSeo } from "@dewo/app/containers/seo/OrganizationSeo";
import { NextPage } from "next";
import { usePermission } from "@dewo/app/contexts/PermissionsContext";
import { useRouter } from "next/router";
import { Header } from "@dewo/app/containers/navigation/header/Header";
import { OrganizationSettings } from "@dewo/app/containers/organization/settings/OrganizationSettings";

const Page: NextPage = () => {
  const organization = useOrganizationFromRouterQuery();
  const canUpdateOrganization = usePermission("update", "Organization");

  const router = useRouter();
  const currentTab =
    (router.query.settingsTab as string | undefined) ?? "general";

  const navigateToSettingsTab = useCallback(
    (tab: string) => router.push(`${organization!.permalink}/settings/${tab}`),
    [organization, router]
  );

  useEffect(() => {
    if (!!organization && canUpdateOrganization === false) {
      router.push(organization.permalink);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!!organization, canUpdateOrganization]);

  return (
    <>
      <Header title="Organization Settings" />
      {!!organization && (
        <div className="max-w-lg w-full dewo-layout-padding-vertical">
          <OrganizationSettings
            organizationId={organization.id}
            currentTab={currentTab}
            onTabClick={navigateToSettingsTab}
          />
        </div>
      )}
      <OrganizationSeo />
    </>
  );
};

export default Page;
